/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import {
  Collapse,
  Input,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Modal
} from "reactstrap";

// Requests
import { getUserRequest } from '../../api/user';
// Helpers
import { clearCredentials, getCredentials, setCredentials } from '../../helpers/auth';
// Assets
import logo from '../../assets/img/logo.png'
// Context
import ProjectContext from "contexts/ProjectContext";
class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      modalSearch: false,
      color: "navbar-transparent",
      _id: '',
      main_balance: '',
      filtersProjects: {},
      selectOption: 0
    };
  }

  async componentDidMount() {
    this.previosContext = this.context;

    const { loadContextProjects } = this.context;
    const { filtersProjects } = this.state;
    
    let selectOption = 0;
    let loadedProjects = await loadContextProjects(filtersProjects)
    
    const localProject = JSON.parse(localStorage.getItem('selectedProject'));
    
    if(localProject) {
      selectOption = loadedProjects.findIndex(obj => obj._id === localProject.selectedProject);
    }
    
    window.addEventListener("resize", this.updateColor);
    const auth = getCredentials();
    
    this.setState({
        _id: auth._id,
        main_balance: auth.main_balance,
        selectOption
    })
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateColor);
  }

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  updateColor = () => {
    if (window.innerWidth < 993 && this.state.collapseOpen) {
      this.setState({
        color: "bg-white"
      });
    } else {
      this.setState({
        color: "navbar-transparent"
      });
    }
  };
  // this function opens and closes the collapse on small devices
  toggleCollapse = () => {
    if (this.state.collapseOpen) {
      this.setState({
        color: "navbar-transparent"
      });
    } else {
      this.setState({
        color: "bg-white"
      });
    }
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // this function is to open the Search modal
  toggleModalSearch = () => {
    this.setState({
      modalSearch: !this.state.modalSearch
    });
  };

  goTo = path => this.props.history.push(path);

  handleLogout = () => {
    clearCredentials();
    this.props.history.push('/auth/login');
  }

  refreshBalance = async () => {
    const { _id } = this.state;

    try {
        const updatedUser = await getUserRequest(_id)
        setCredentials(updatedUser);
        this.setState({
            main_balance: updatedUser.main_balance,
        })
    } catch (error) {
        this.showErrorAlert(error);
    }
  }

  handleProject = (index) => {
    const { handleSelectProject, loadedProjects} = this.context;

    const data = {
      data: loadedProjects[index],
      label: `${loadedProjects[index].name}`,
      value: loadedProjects[index]._id
    }

    this.setState({
      selectOption: index
    })

    handleSelectProject(data)
  }

  render() {
    const {
      selectOption
    } = this.state;

    const {
      loadedProjects = []
    } = this.context

    return (
      <>
        <Navbar
          className={classNames("navbar-absolute", {
            [this.state.color]:
              this.props.location.pathname.indexOf("full-screen-map") === -1
          })}
          expand="lg"
        >
          <Container fluid >
            <div className="navbar-wrapper">
              {/*<div className="navbar-minimize d-inline">
                <Button
                  className="minimize-sidebar btn-just-icon"
                  color="link"
                  id="tooltip209599"
                  onClick={this.props.handleMiniClick}
                >
                  <i className="tim-icons icon-align-center visible-on-sidebar-regular" />
                  <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini" />
                </Button>
                <UncontrolledTooltip
                  delay={0}
                  target="tooltip209599"
                  placement="right"
                >
                  Sidebar toggle
                </UncontrolledTooltip>
              </div>*/}
              <div
                className={classNames("navbar-toggle d-inline", {
                  toggled: this.props.sidebarOpened
                })}
              >
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={this.props.toggleSidebar}
                >
                  <span className="navbar-toggler-bar bar1" />
                  <span className="navbar-toggler-bar bar2" />
                  <span className="navbar-toggler-bar bar3" />
                </button>
              </div>
              <NavbarBrand href="#logo" onClick={e => e.preventDefault()}>
                <img className="navbar-logo" src={logo} alt="PMT System" />
              </NavbarBrand>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navigation"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
              <span className="navbar-toggler-bar navbar-kebab" />
            </button>
            <div className="w-75 d-flex justify-content-center">
            {/* <Async
							clearValue={""}
							value={selectedProject}
							name="selectedProject"
							options={[]}
							loadOptions={this.loadProjects}
							className="basic-multi-select navbar-select"
							classNamePrefix="select"
							onChange={handleSelectProject()}
							placeholder="Projects..."
							isClearable={true}
              style={{width: '300px'}}
						/> */}
            <Input
							value={selectOption}
							onChange={e => this.handleProject(e.target.value)}
							placeholder="Projects..."
              className="navbar-select"
              type="select"
						>
              {loadedProjects.length > 0 ? loadedProjects.map((project, index) => (
                <option key={project._id} value={index}>{project.name}</option>
              ))
            : (
              <option value=''>Don't have projects</option>
            )}
            </Input>
            </div>
            <Collapse isOpen={this.state.collapseOpen} navbar>
              <Nav navbar className="ml-auto" >
                <NavItem>
                  <NavLink onClick={() => this.handleLogout()} className="nav-link clickable">
                    Log Out
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
        <Modal
          modalClassName="modal-search"
          isOpen={this.state.modalSearch}
          toggle={this.toggleModalSearch}
        >
          <div className="modal-header">
            <Input id="inlineFormInputGroup" placeholder="SEARCH" type="text" />
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={this.toggleModalSearch}
            >
              <i className="tim-icons icon-simple-remove" />
            </button>
          </div>
        </Modal>
      </>
    );
  }
}

AdminNavbar.contextType = ProjectContext;

export default AdminNavbar;